export { default } from './CareIcon';
